import { createSlice } from "@reduxjs/toolkit";

export const markingSlice = createSlice({
  name: "marking",
  initialState: {
    year: "",
    classId: "",
    className: "",
    subjectId: "",
    subjectName: "",
    categoryNameOne: "",
    categoryIndex: "",
    classNavId: "",
    overviewTabIndex:0,
  },
  reducers: {
    setYear: (state, action) => {
      state.year = action.payload;
    },
    setClassId: (state, action) => {
      state.classId = action.payload;
    },
    setClassName: (state, action) => {
      state.className = action.payload;
    },
    setSubjectId: (state, action) => {
      state.subjectId = action.payload;
    },
    setSubjectName: (state, action) => {
      state.subjectName = action.payload;
    },
    setCategory: (state, action) => {
      state.categoryNameOne = action.payload;
    },
    setCategoryIndex: (state, action) => {
      state.categoryIndex = action.payload;
    },
    setClassNavId: (state, action) => {
      state.classNavId = action.payload;
    },
    setOverviewTabIndex: (state, action) => {
      state.overviewTabIndex = action.payload;
    },
  },
});

export const {
  setYear,
  setClassId,
  setClassName,
  setSubjectId,
  setSubjectName,
  setCategory,
  setCategoryIndex,
  setClassNavId,
  setOverviewTabIndex,
} = markingSlice.actions;
export default markingSlice.reducer;
